import i18n from "i18next";
import { load, loadAppContext, showConfirmDialog, closeModal, showSlideout } from "./appSlice";
import { selectAppLanguage } from "./appSelectors";
import { AppThunk } from "../store";
import initI18next from "../../utils/i18nInit";
import type { SlideoutProps } from "../../components/Modals/Slideout";
import { ConfirmDialogProps } from "../../calculator/components/ConfirmDialog";
import { waitForTrackingToBeReady } from "../../utils/tracking";

export const loadThunk = (): AppThunk => async (dispatch, getState) => {
  const i18nTask = initI18next();
  dispatch(loadAppContext());
  await i18nTask;
  const language = selectAppLanguage(getState());
  await i18n.changeLanguage(language);
  dispatch(load());
};

export const loadTrackingThunk = (): AppThunk => async () => {
  await waitForTrackingToBeReady();
};

export const showConfirmDialogThunk =
  (payload: {
    header?: string;
    body?: string;
    dismissButtonText?: string;
    confirmButtonText?: string;
    onCancel?: (payload: { id: string }) => void;
    onConfirm: (payload: { id: string }) => void;
    onClose?: (payload: { id: string }) => void;
  }): AppThunk =>
  (dispatch) => {
    const actionPayload: Omit<ConfirmDialogProps, "id"> = {
      ...payload,
      onClose:
        payload.onClose ??
        (({ id }: { id: string }) => {
          dispatch(closeModalThunk({ id }));
        }),
      onCancel:
        payload.onCancel ??
        (({ id }: { id: string }) => {
          dispatch(closeModalThunk({ id }));
        }),
    };

    dispatch(showConfirmDialog(actionPayload));
  };

export const closeModalThunk =
  (payload: { id: string }): AppThunk =>
  (dispatch) => {
    const actionPayload = { ...payload };

    dispatch(closeModal(actionPayload));
  };

export const showSlideoutThunk =
  (payload: { header: string; body: string; onClose?: (payload: { id: string }) => void }): AppThunk =>
  (dispatch) => {
    const actionPayload: Omit<SlideoutProps, "id"> = {
      ...payload,
      onClose:
        payload.onClose ??
        (({ id }: { id: string }) => {
          dispatch(closeModalThunk({ id }));
        }),
    };

    dispatch(showSlideout(actionPayload));
  };
